import api from 'api';

// eslint-disable-next-line import/prefer-default-export
export const getStatsSharingTokenInfos = (token: string) => async (): Promise<{ salesforce_account_name: string }> => {
  const res = await api.getStatsSharingTokenInfos(token);
  return res.data;
};
